// Tracking for Heap
export const HEAP_PAGE_AREA = 'category-browse';
